<template>
    <div class="mobile-tab-bar">
        <div
            v-for="item in tabs"
            :key="item.path"
            class="tab-item"
            :class="{ active: isActive(item.path) }"
            @click="go(item.path)"
        >
            <component :is="item.icon" class="tab-icon" />
            <span class="tab-label">{{ item.label }}</span>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {
    IconLayout,
    IconCalendar,
    IconCheckCircle,
    IconFile,
    IconSettings
} from '@arco-design/web-vue/es/icon';

export default {
    name: 'MobileTabBar',
    components: {
        IconLayout,
        IconCalendar,
        IconCheckCircle,
        IconFile,
        IconSettings
    },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const tabs = computed(() => [
            { path: '/dashboard', label: '工作台', icon: IconLayout },
            { path: '/payRecord', label: '支出', icon: IconCalendar },
            { path: '/todoRecord', label: '待办', icon: IconCheckCircle },
            { path: '/document', label: '文档', icon: IconFile },
            { path: '/settings', label: '设置', icon: IconSettings },
        ]);

        const isActive = (path) => route.path === path;

        const go = (path) => {
            if (route.path === path) return;
            router.push(path);
        };

        return { tabs, isActive, go };
    }
};
</script>

<style scoped>
.mobile-tab-bar {
    display: flex;
    align-items: center;
    justify-content: space-around;
    height: 56px;
    padding-bottom: env(safe-area-inset-bottom);
    background: rgba(255, 255, 255, 0.96);
    backdrop-filter: blur(10px);
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    flex-shrink: 0;
}

.tab-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
    min-width: 56px;
    padding: 6px 4px;
    cursor: pointer;
    color: #86909c;
    -webkit-tap-highlight-color: transparent;
}

.tab-icon {
    font-size: 22px;
}

.tab-label {
    font-size: 11px;
    line-height: 1.2;
}

.tab-item.active {
    color: #667eea;
    font-weight: 600;
}
</style>

<style>
/* 暗色模式：底部导航 */
body[arco-theme='dark'] .mobile-tab-bar {
    background: rgba(29, 33, 41, 0.96);
    border-top-color: var(--color-border-1);
}
body[arco-theme='dark'] .tab-item {
    color: var(--color-text-3);
}
body[arco-theme='dark'] .tab-item.active {
    color: #667eea;
}
</style>
